import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { includes } from '@/utils/lodash'
import { connect } from 'react-redux'
import { Sidebar, Header, Footer } from '@/layout-components'
import { Outlet } from 'react-router'
import { Box } from '@mui/material'
import SuspenseLoading from '@/housefolios-components/Routes/SuspenseLoading'
import {
  wrapperSx,
  mainOffsetSx,
  contentSx,
  contentInnerSx,
  contentInnerWrapperSx,
  fullBleedContentInnerSx,
  fullBleedContentInnerWrapperSx,
} from '../chromeSx'

const LeftSidebar = (props) => {
  const {
    sidebarToggle,
    sidebarFixed,
    headerFixed,
    setOpenFeedbackTour,
  } = props
  const isFullBleedDashboard =
    includes(window.location.href, 'property-details') ||
    includes(window.location.href, 'editLot')
  return (
    <Box data-hf="chrome-wrapper" sx={wrapperSx}>
      <Sidebar
        collapsed={props.collapsed}
        setOpenFeedbackTour={setOpenFeedbackTour}
      />
      <Box
        sx={mainOffsetSx({
          sidebarFixed,
          collapsed: sidebarToggle,
       })}
      >
        <Header
          collapsed={props.collapsed}
          hideBackButton={props.hideBackButton}
        />
        <Box
          sx={{
            ...contentSx({ headerFixed  }),
            ...(isFullBleedDashboard
              ? { overflow: 'hidden' }
              : {}),
          }}
        >
          <Box
            sx={
              isFullBleedDashboard
                ? fullBleedContentInnerSx
                : contentInnerSx({ compact: props.hideBackButton  })
            }
          >
            <Box
              sx={
                isFullBleedDashboard
                  ? fullBleedContentInnerWrapperSx
                  : contentInnerWrapperSx
              }
            >
              <Suspense fallback={<SuspenseLoading />}>
                <Outlet />
              </Suspense>
            </Box>
          </Box>
          {!includes(window.location.href, 'property-details') &&
            !includes(window.location.href, 'editLot') && <Footer />}
        </Box>
      </Box>
    </Box>
  )
}

LeftSidebar.propTypes = {
  children: PropTypes.node,
}

const mapStateToProps = (state) => ({
  sidebarToggle: state.DeprecatedThemeOptions.sidebarToggle,
  sidebarToggleMobile:
    state.DeprecatedThemeOptions.sidebarToggleMobile,
  sidebarFixed: state.DeprecatedThemeOptions.sidebarFixed,
  headerFixed: state.DeprecatedThemeOptions.headerFixed,
  headerSearchHover: state.DeprecatedThemeOptions.headerSearchHover,
  headerDrawerToggle: state.DeprecatedThemeOptions.headerDrawerToggle,
  notificationsDrawerToggle:
    state.DeprecatedThemeOptions.notificationsDrawerToggle,

  footerFixed: state.DeprecatedThemeOptions.footerFixed,
})

export default connect(mapStateToProps)(LeftSidebar)
